import { useLocation } from "react-router-dom";

import { type InstallableApp } from "~/pwa/installableApps";
import isStandaloneDisplay from "~/pwa/isStandaloneDisplay";
import resolveStandaloneApp from "~/pwa/resolveStandaloneApp";
import standaloneLaunch from "~/pwa/standaloneLaunch";

const useStandaloneApp = (): { activeApp: InstallableApp | null; isConfined: boolean } => {
	const { pathname } = useLocation();
	const { app: launchedApp, isRootSession } = standaloneLaunch.resolve();
	if (launchedApp) return { activeApp: launchedApp, isConfined: true };
	if (isRootSession) return { activeApp: null, isConfined: false };

	const { app } = resolveStandaloneApp(isStandaloneDisplay(), null, pathname);
	if (app) return { activeApp: app, isConfined: true };

	return { activeApp: null, isConfined: false };
};

export default useStandaloneApp;
